import { render, staticRenderFns } from "./oriTable.vue?vue&type=template&id=1c27cd66&scoped=true"
import script from "./oriTable.vue?vue&type=script&lang=js"
export * from "./oriTable.vue?vue&type=script&lang=js"
import style0 from "./oriTable.vue?vue&type=style&index=0&id=1c27cd66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c27cd66",
  null
  
)

export default component.exports